<template>
    <client-page>
        <sub-visual subTab sh="Project / Reference" index="02" total="02" tabActive="Reference" bg="/images/sub/visual/sv3.jpg"> </sub-visual>

        <section class="section section--first section--last">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">Global Reference</h2>
                </div>

                <div class="reference-tab mb-30 mb-md-40 mb-lg-70">
                    <ul>
                        <li>
                            <button class="reference-tab__btn" :class="{ active: americaMenu }" @mouseenter="americaMenu = true" @mouseleave="americaMenu = false">
                                <span class="reference-tab__dot"></span>
                                <span class="reference-tab__txt">아메리카</span>
                            </button>
                        </li>
                        <li>
                            <button class="reference-tab__btn" :class="{ active: middleEastMenu }" @mouseenter="middleEastMenu = true" @mouseleave="middleEastMenu = false">
                                <span class="reference-tab__dot"></span>
                                <span class="reference-tab__txt">중앙아시아</span>
                            </button>
                        </li>
                        <li>
                            <button class="reference-tab__btn" :class="{ active: cisNationsMenu }" @mouseenter="cisNationsMenu = true" @mouseleave="cisNationsMenu = false">
                                <span class="reference-tab__dot"></span>
                                <span class="reference-tab__txt">독립국가연합</span>
                            </button>
                        </li>
                        <li>
                            <button class="reference-tab__btn" :class="{ active: koreaMenu }" @mouseenter="koreaMenu = true" @mouseleave="koreaMenu = false">
                                <span class="reference-tab__dot"></span>
                                <span class="reference-tab__txt">대한민국</span>
                            </button>
                        </li>
                        <li>
                            <button class="reference-tab__btn" :class="{ active: asiaMenu }" @mouseenter="asiaMenu = true" @mouseleave="asiaMenu = false">
                                <span class="reference-tab__dot"></span>
                                <span class="reference-tab__txt">아시아</span>
                            </button>
                        </li>
                    </ul>
                </div>

                <div class="map">
                    <div class="map__img"><img src="/images/sub/reference/map.png" alt="이미지" /></div>

                    <!-- S: america -->
                    <v-menu v-model="americaMenu" v-show="$vuetify.breakpoint.lgAndUp" top offset-y content-class="map__menu">
                        <template v-slot:activator="{ on, attrs }">
                            <button v-bind="attrs" v-on="on" class="map__btn map__america" @click="americaDialog = true" @mouseenter="americaMenu = true" @mouseleave="americaMenu = false"></button>
                        </template>

                        <div class="map__menu-inner" @click="americaDialog = true">아메리카</div>
                    </v-menu>

                    <button
                        class="map__btn map__america d-lg-none"
                        @click="
                            referenceCon();
                            americaCon = true;
                        "
                    ></button>
                    <u-dialog v-model="americaDialog" @close="americaDialog = false">
                        <America />
                    </u-dialog>
                    <!-- E: america -->

                    <!-- S: middleEast -->
                    <v-menu v-model="middleEastMenu" v-show="$vuetify.breakpoint.lgAndUp" top offset-y content-class="map__menu">
                        <template v-slot:activator="{ on, attrs }">
                            <button v-bind="attrs" v-on="on" class="map__btn map__middle-east" @click="middleEastDialog = true" @mouseenter="middleEastMenu = true" @mouseleave="middleEastMenu = false"></button>
                        </template>

                        <div class="map__menu-inner" @click="middleEastDialog = true">
                            중앙아시아
                        </div>
                    </v-menu>

                    <button
                        class="map__btn map__middle-east d-lg-none"
                        @click="
                            referenceCon();
                            middleEastCon = true;
                        "
                    ></button>
                    <u-dialog v-model="middleEastDialog" @close="middleEastDialog = false">
                        <MiddleEast />
                    </u-dialog>
                    <!-- E: middleEast -->

                    <!-- S: cisNations -->
                    <v-menu v-model="cisNationsMenu" v-show="$vuetify.breakpoint.lgAndUp" top offset-y content-class="map__menu">
                        <template v-slot:activator="{ on, attrs }">
                            <button v-bind="attrs" v-on="on" class="map__btn map__cis-nations" @click="cisNationsDialog = true" @mouseenter="cisNationsMenu = true" @mouseleave="cisNationsMenu = false"></button>
                        </template>

                        <div class="map__menu-inner" @click="cisNationsDialog = true">
                            독립국가연합
                        </div>
                    </v-menu>

                    <button
                        class="map__btn map__cis-nations d-lg-none"
                        @click="
                            referenceCon();
                            cisNationsCon = true;
                        "
                    ></button>
                    <u-dialog v-model="cisNationsDialog" @close="cisNationsDialog = false">
                        <CisNations />
                    </u-dialog>
                    <!-- E: cisNations -->

                    <!-- S: korea -->
                    <v-menu v-model="koreaMenu" v-show="$vuetify.breakpoint.lgAndUp" top offset-y content-class="map__menu">
                        <template v-slot:activator="{ on, attrs }">
                            <button v-bind="attrs" v-on="on" class="map__btn map__korea" @click="koreaDialog = true" @mouseenter="koreaMenu = true" @mouseleave="koreaMenu = false"></button>
                        </template>

                        <div class="map__menu-inner" @click="koreaDialog = true">
                            대한민국
                        </div>
                    </v-menu>

                    <button
                        class="map__btn map__korea d-lg-none"
                        @click="
                            referenceCon();
                            koreaCon = true;
                        "
                    ></button>
                    <u-dialog v-model="koreaDialog" @close="koreaDialog = false">
                        <Korea />
                    </u-dialog>
                    <!-- E: korea -->

                    <!-- S: asia -->
                    <v-menu v-model="asiaMenu" v-show="$vuetify.breakpoint.lgAndUp" top offset-y content-class="map__menu">
                        <template v-slot:activator="{ on, attrs }">
                            <button v-bind="attrs" v-on="on" class="map__btn map__asia" @click="asiaDialog = true" @mouseenter="asiaMenu = true" @mouseleave="asiaMenu = false"></button>
                        </template>

                        <div class="map__menu-inner" @click="asiaDialog = true">
                            아시아
                        </div>
                    </v-menu>

                    <button
                        class="map__btn map__asia d-lg-none"
                        @click="
                            referenceCon();
                            asiaCon = true;
                        "
                    ></button>
                    <u-dialog v-model="asiaDialog" @close="asiaDialog = false">
                        <Asia />
                    </u-dialog>
                    <!-- E: asia -->
                </div>

                <div class="d-lg-none pt-60">
                    <America v-show="americaCon" />
                    <MiddleEast v-show="middleEastCon" />
                    <CisNations v-show="cisNationsCon" />
                    <Korea v-show="koreaCon" />
                    <Asia v-show="asiaCon" />
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import UDialog from "@/components/dumb/u-dialog.vue";
import America from "@/pages/client/ko/sub/reference/America.vue";
import MiddleEast from "@/pages/client/ko/sub/reference/MiddleEast.vue";
import CisNations from "@/pages/client/ko/sub/reference/CisNations.vue";
import Korea from "@/pages/client/ko/sub/reference/Korea.vue";
import Asia from "@/pages/client/ko/sub/reference/Asia.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        UDialog,

        America,
        MiddleEast,
        CisNations,
        Korea,
        Asia,
    },
    data() {
        return {
            americaDialog: false,
            americaMenu: false,
            americaCon: true,
            middleEastDialog: false,
            middleEastMenu: false,
            middleEastCon: false,
            cisNationsDialog: false,
            cisNationsMenu: false,
            cisNationsCon: false,
            koreaDialog: false,
            koreaMenu: false,
            koreaCon: false,
            asiaDialog: false,
            asiaMenu: false,
            asiaCon: false,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
        referenceCon: function() {
            return (this.americaCon = false), (this.middleEastCon = false), (this.cisNationsCon = false), (this.koreaCon = false), (this.asiaCon = false);
        },
    },
};
</script>

<style lang="scss" scoped>
.reference-tab {
    display: none;
    position: relative;
    &::before {
        content: "";
        position: absolute;
        top: 5px;
        left: 50%;
        -webkit-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
        display: block;
        width: 100vw;
        height: 2px;
        background-color: var(--border-color);
    }
    > ul {
        display: flex;
        justify-content: space-between;
    }
    &__btn {
        position: relative;
        z-index: 1;
        &.active {
            .reference-tab {
                & {
                    &__dot {
                        border: 2px solid var(--v-primary-base);
                        background-color: #fff;
                    }
                    &__txt {
                        color: var(--v-primary-base);
                    }
                }
            }
        }
    }
    &__dot {
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 100%;
        background-color: #999;
        margin: auto;
    }
    &__txt {
        display: block;
        font-size: 1.8rem;
        font-weight: 700;
        color: #999;
        padding-top: 14px;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .reference-tab {
        display: block;
    }
}
@media (min-width: 1200px) {
}

.map {
    position: relative;
    &__btn {
        position: absolute;
        z-index: 1;
        width: 6px !important;
        height: 6px !important;
        border-radius: 100%;
        background-color: #999;
    }
    &__america {
        top: 51.23762376237624%;
        left: 17.08333333333333%;
    }
    &__middle-east {
        top: 47.02970297029703%;
        left: 58.61111111111111%;
    }
    &__cis-nations {
        top: 25.99009900990099%;
        left: 70.41666666666667%;
    }
    &__korea {
        top: 40.0990099009901%;
        left: 82.77777777777778%;
    }
    &__asia {
        top: 65.34653465346535%;
        left: 81.38888888888889%;
    }
}
.map__menu {
    transform: translate(calc(-50% + 6px), 0);
    width: 240px;
    box-shadow: none !important;
    overflow: visible;
    contain: none;
}
.map__menu-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 86px;
    font-size: 1.8rem;
    font-weight: 700;
    color: #111;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.08);
    cursor: pointer;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .map {
        &__btn {
            width: 12px !important;
            height: 12px !important;
        }
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
@media (min-width: 1440px) {
    .map__menu {
        padding-bottom: 48px;
        &::before {
            content: "";
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 0);
            display: block;
            width: 1px;
            height: 48px;
            background-color: var(--v-primary-base);
        }
    }
}
</style>
